/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/Fandango.constants.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'Fandango/constants', exports: {} }; const exports = module.exports;

export const HTTPStatusCodes = Object.freeze({
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    INTERNAL_SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
});
export default { HTTPStatusCodes };